<template>
    <van-popup v-if="addApprovalPopupShow " :value="addApprovalPopupShow" z-index="100" :close-on-click-overlay="false"
               :style="{ height: '100vh',width: '100vw', background: 'rgba(0,0,0,.3)' }" overlay-class="custom_popup" position="right">
        <div class="add_approval_wrap"  v-loading="loading">
            <div class="add_approval_top">
                <div class="returnNavBar">
                    <div class="returnNavBarLeft" @click="handleClickClose">
                        <van-icon  name="arrow-left" />
                        <span class="normal_title">返回</span>
                    </div>
                </div>
            </div>
            <div class="add_approval_bottom">
                <ul>
                    <li v-for="item in approvalSetTypeList" @click="handleClickAddApproval(item)" >
                        <div class="icon">
                            <img :src="item.icon" alt="">
                        </div>
                        <p v-text="item.name"></p>
                    </li>
                </ul>
            </div>

        </div>
    </van-popup>
</template>

<script>
import {getApprovalType}from "@/api/index.js"
export default {
    name: "add_approval",
    components: { },
    props: {
        addApprovalPopupShow: {
            type: Boolean,
            default: false
        },
        projectId: {
            type: Number,
            default: '0'
        },


    },
    data() {
        return {
            defaultImg: require('@/assets/images/default.jpg'),
            loading:false,
            btnDisabled:false,
            approvalSetTypeList:[]
        };
    },

    created() {
        this.getApprovalType()
    },
    methods: {
        handleClickAddApproval(item){
            this.$router.push({
                name: 'mobileApproveAdd',
                query:{
                    id:item.approval_set_id,
                    name:item.name,
                    type:item.type
                },
                params: {}
            })
        },

        // 获取可选的审批类型
        getApprovalType(keyword){
            let postData = {
                approval_types:{
                    controls:[
                        'control_payable'
                    ],
                    type:[
                        'purchase'
                    ]
                }
            }
            getApprovalType(postData).then(res => {
                if (res.code === 200) {
                    const {data} = res
                    this.approvalSetTypeList = data
                }
            })
        },
        handleClickClose(){
            this.$emit("update:addApprovalPopupShow", false)
        },



    },
}
</script>

<style  lang="scss" scoped>
@import "@/styles/m_style/project_management.scss";
</style>